import request from '@/utils/request'

// 分页查询商品列表
export function getGoodsPage(data) {
    return request({
        url: '/admin/goods/page',
        method: 'post',
        data: data
    })
}

// 获取商品详情
export function getGoodsDetail(id) {
    return request({
        url: '/admin/goods/detail?id=' + id,
        method: 'get'
    })
}

// 新增商品
export function insertGoods(data) {
    return request({
        url: '/admin/goods/insert',
        method: 'post',
        data: data
    })
}

// 修改商品
export function updateGoods(data) {
    return request({
        url: '/admin/goods/update',
        method: 'post',
        data: data
    })
}

// 删除商品
export function deleteGoods(id) {
    return request({
        url: '/admin/goods/delete?id=' + id,
        method: 'get'
    })
}

// 分页查询SKU列表
export function getSkuPage(data) {
    return request({
        url: '/admin/goodsSku/page',
        method: 'post',
        data: data
    })
}

// 获取商品的SKU列表
export function getGoodsSkuList(goodsId) {
    return request({
        url: '/admin/goodsSku/list?goodsId=' + goodsId,
        method: 'get'
    })
}

// 批量保存商品SKU
export function batchSaveGoodsSku(data) {
    return request({
        url: '/admin/goodsSku/batch-save',
        method: 'post',
        data: data
    })
}

// 更新SKU
export function updateSku(data) {
    return request({
        url: '/admin/goodsSku/update',
        method: 'post',
        data: data
    })
}
